<panel style="min-width: 400px">
	<div class="row">
		<div class="col-12">
			<h3>{{ 'product.delete-warning' | translate }}</h3>
			<div>{{ 'product.delete-product-text' | translate }}</div>
			<div>{{ productName }}</div>
		</div>
		<div class="offset-6 col-3">
			<div class="button green" [ngClass]="{'disabled': deletingProduct == true}" (click)="close()">{{ 'general.cancel' | translate }}</div>
		</div>
		<div class="col-3">
			<div class="button red" [ngClass]="{'disabled': deletingProduct == true}" (click)="deleteProduct()">{{ 'general.delete' | translate }}</div>
		</div>
	</div>
</panel>
